<div *ngIf="order_summary" class="mt-4 container-md p-md-0">
  <div class="row d-flex flex-column">
    <div class="col">
      <h2 class="display-2">{{ confirmationMsg }}</h2>
    </div>

    <div class="col">
      <h4 class="display-4">{{ 'order_number' | translate }} #{{ this.order_id }}</h4>
    </div>
  </div>

  <ts-order-details
    [order_id]="order_summary.id"
    [related_order_info]="order_summary.related_order_info"
    [related_order_url]="order_summary.related_order_url"
    [order_type_id]="order_summary.store_order_type_id"
    [price_summary]="order_summary.order_price_summary"
    [source_order_details]="order_summary.source_order"
    [order_tracker]="order_summary.order_tracker"
    [asset_details]="asset_details"
    [additional_info]="order_summary.store_order_additional_info"
    [order_status_desc]="order_status_desc"
  >
    <footer navigate-dashboard class="fixed-bottom border-top">
      <div class="container-md p-md-0">
        <div class="row py-4 d-flex justify-content-end">
          <div class="col d-grid col-12 col-md-4 col-lg-3">
            <button type="button" class="btn btn-outline-secondary" [routerLink]="[homeUrl]">
              {{ 'return_to_dashboard' | translate }}
            </button>
          </div>
        </div>
      </div>
    </footer>
  </ts-order-details>
</div>
